import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { getControlList, getControlListFormTask } from '@/api/correspondence/task/control';
export default {
  name: 'correspondence-control-list',
  props: {
    id: {
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    return {
      searchKey: '',
      byGroup: false,
      dataList: [],
      loading: false,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 0,
      handleFn: null
    };
  },
  methods: {
    search: function search() {
      this.handleCurrentChange(1);
    },
    detail: function detail(row) {
      var taskId = this.id ? this.id : row.c01Id;
      var params = {
        code: row.c04C01Code,
        type: row.c04CpnfirmType,
        cusName: row.c04CusName,
        perior: row.c04Perior
      };
      this.$router.push("/correspondence/control-list-detail/".concat(taskId, "/").concat(row.c04Id, "?params=").concat(JSON.stringify(params)));
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, res, headers, data, pagination;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _context.n = 1;
              return _this.$awaitTo(_this.handleFn({
                PageNumber: _this.pageNumber,
                PageSize: _this.pageSize,
                SearchQuery: _this.searchKey ? "c04CusName.contains(\"".concat(_this.searchKey, "\")") : ''
              }, _this.id));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              res = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              headers = res.headers, data = res.data;
              if (Array.isArray(data)) {
                _this.dataList = data;
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this.totalPages = JSON.parse(pagination).totalCount;
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.handleFn = getControlList;
    if (this.id) {
      this.handleFn = getControlListFormTask;
    }
    this.getList();
  }
};